import React from 'react';
import { Formik } from 'formik';
import { PropTypes } from 'prop-types';
import * as yup from 'yup';
import { Modal, GridRow, GraphAutoComplete, MobileSpacer, Grid, Text } from '@custom-components';
import { ADMIN_SEARCH_PROPERTIES } from '@containers/AutoCompleteContainer/gql';
import { flowRight as compose } from 'lodash';
import { ADMIN_SEARCH_SUPPLIERS } from '../../../containers/AutoCompleteContainer/gql';
import withAuth from '../../../hocs/withAuth';
import { Content } from './styles';

class ChangePropertyOrgModal extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func.isRequired,
    openModal: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState() {
    return {
      propertyName: { value: '', query: '' },
      supplierName: { value: '', query: '' }
    };
  }

  resetState = () => {
    this.setState(this.getInitialState());
  };

  validationSchema = () =>
    yup.object().shape({
      propertyName: yup.object().shape({
        query: yup.string().required('Must select a property')
      }),
      supplierName: yup.object().shape({
        query: yup.string().required('Must select a designated supplier')
      })
    });

  handleDetailChange = (name, { query, value }) => {
    this.setState({
      [name]: { value, query }
    });
  };

  submit = (values, { resetForm }) => {
    const { handleChange } = this.props;
    const { propertyName, supplierName } = this.state;
    handleChange({ propertyName, supplierName });
    resetForm();
    this.resetState();
  };

  render() {
    const { propertyName, supplierName } = this.state;
    const { closeModal, openModal } = this.props;

    return (
      <Formik
        initialValues={{
          propertyName: { value: '', query: '' },
          supplierName: { value: '', query: '' }
        }}
        onSubmit={this.submit}
        validationSchema={this.validationSchema()}
      >
        {({ resetForm, handleSubmit, setFieldValue, values, errors, submitCount }) => (
          <Modal
            disableEnforceFocus
            openModal={openModal}
            handleClose={() => {
              resetForm();
              this.resetState();
              closeModal();
            }}
            title="CHANGE PROPERTY SUPPLIER"
            actions={[
              {
                label: 'CANCEL',
                onClick: () => {
                  resetForm();
                  this.resetState();
                  closeModal();
                },
                btnTheme: 'secondary'
              },
              {
                label: 'APPLY',
                onClick: () => handleSubmit(),
                btnTheme: 'primary'
              }
            ]}
          >
            <Content>
              <Text.CopyBody>
                {`You are about to change the supplier of ${propertyName.query || 'a property'} to ${
                  supplierName.query || 'another supplier'
                }. Select a property and a designated supplier before proceeding.`}
              </Text.CopyBody>
              <GridRow>
                <Grid.Col sm={16} md={8}>
                  Search for a property using the typeahead
                </Grid.Col>
                <MobileSpacer lessThan="md" />
                <Grid.Col lg={12}>
                  <GraphAutoComplete
                    name="propertyName"
                    value={values.propertyName}
                    label="Property"
                    setFieldValue={(field, value) => setFieldValue(field, value)}
                    onValueChange={(name, value) => {
                      if (value) this.handleDetailChange('propertyName', value);
                    }}
                    graphql={{
                      accessString: 'AdminQueries.propertyTypeahead',
                      query: ADMIN_SEARCH_PROPERTIES,
                      mapper: (data) =>
                        data.map((item) => ({
                          label: item.name,
                          value: item.id.toString()
                        })),
                      variables: (value) => ({ propertyName: value.query })
                    }}
                    variant="standard"
                    error={!!errors.propertyName?.query && submitCount > 0}
                    errorText={errors.propertyName?.query}
                    required
                  />
                </Grid.Col>
              </GridRow>
              <GridRow>
                {' '}
                <Grid.Col sm={16} md={8}>
                  Search for a supplier using the typeahead
                </Grid.Col>
                <MobileSpacer lessThan="md" />
                <Grid.Col lg={12}>
                  <GraphAutoComplete
                    name="supplierName"
                    value={values.supplierName}
                    label="Designated Supplier"
                    setFieldValue={setFieldValue}
                    onValueChange={(name, value) => {
                      if (value) this.handleDetailChange('supplierName', value);
                    }}
                    graphql={{
                      accessString: 'AdminQueries.supplierTypeahead',
                      query: ADMIN_SEARCH_SUPPLIERS,
                      mapper: (data) =>
                        data.map((item) => ({
                          label: item.name,
                          value: item.id.toString()
                        })),
                      variables: (value) => ({ supplierName: value.query })
                    }}
                    variant="standard"
                    error={!!errors.supplierName?.query && submitCount > 0}
                    errorText={errors.supplierName?.query}
                    required
                  />
                </Grid.Col>
              </GridRow>
            </Content>
          </Modal>
        )}
      </Formik>
    );
  }
}
export default compose(withAuth())(ChangePropertyOrgModal);
